import styled from 'styled-components'

export const LiveContainer = styled.div`
  iframe {
    min-height: 100vh;
    width: 100%;
  }
`
